// ============================================
// FILE: src/pages/admin/Orders.jsx
// ============================================
import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import Navbar from '../../components/Navbar';

const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/orders`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setOrders(data.orders || []);
      } else {
        console.log('API error:', response.status, response.statusText);
        setOrders([]);
        toast.error('Failed to load orders');
      }
    } catch (error) {
      console.error('Orders fetch error:', error);
      setOrders([]);
      toast.error('Network error - check backend connection');
    }
    setLoading(false);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'pending': return 'bg-yellow-100 text-yellow-800';
      case 'confirmed': return 'bg-blue-100 text-blue-800';
      case 'preparing': return 'bg-purple-100 text-purple-800';
      case 'ready': return 'bg-indigo-100 text-indigo-800';
      case 'shipped': return 'bg-orange-100 text-orange-800';
      case 'delivered': return 'bg-green-100 text-green-800';
      case 'cancelled': return 'bg-red-100 text-red-800';
      case 'rejected': return 'bg-gray-100 text-gray-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="min-h-screen bg-cover bg-center bg-fixed" style={{ backgroundImage: "url('/images/trade-bg.jpg')" }}>
      <div className="min-h-screen bg-black/40 w-full pb-10">
        <Navbar userType="admin" />

        <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
          <div className="px-4 py-6 sm:px-0">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">All Orders</h1>

            {loading ? (
              <div className="text-center py-12">Loading orders...</div>
            ) : orders.length === 0 ? (
              <div className="text-center py-12">
                <p className="text-gray-500">No orders found</p>
              </div>
            ) : (
              <div className="bg-white shadow overflow-hidden sm:rounded-md">
                <ul className="divide-y divide-gray-200">
                  {orders.map((order) => (
                    <li key={order.id} className="px-6 py-4">
                      <div className="flex items-center justify-between">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center">
                            <div className="flex-1 min-w-0">
                              <p className="text-lg font-medium text-gray-900">
                                Order #{order.order_number}
                              </p>
                              <p className="text-sm text-gray-600">
                                Customer: {order.user_name} • Supplier: {order.business_name}
                              </p>
                              <p className="text-sm text-gray-500">
                                Date: {new Date(order.created_at).toLocaleDateString()} • Amount: ₹{order.total_amount}
                              </p>
                              <div className="flex items-center space-x-4 mt-2">
                                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(order.order_status)}`}>
                                  Order: {order.order_status.charAt(0).toUpperCase() + order.order_status.slice(1)}
                                </span>
                                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${order.payment_status === 'completed' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                                  }`}>
                                  Payment: {order.payment_status.charAt(0).toUpperCase() + order.payment_status.slice(1)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="ml-4 flex-shrink-0 flex space-x-2">
                          <button className="text-blue-600 hover:text-blue-900 text-sm px-3 py-1 border border-blue-600 rounded hover:bg-blue-50">
                            View Details
                          </button>
                          <button className="text-purple-600 hover:text-purple-900 text-sm px-3 py-1 border border-purple-600 rounded hover:bg-purple-50">
                            Update Status
                          </button>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminOrders;